import React, { Component } from "react";
import _ from "lodash";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

// // Shared layouts
import { Dashboard as DashboardLayout } from "layouts";
import { SearchInput, EditIntent } from "components";
import { IntentsEnabledList } from "./components";
import { Grid, Divider } from "@material-ui/core";
import { fetchConnection } from "../../redux/actions/connectionActions";
import { checkBotStatus, buildBot } from "../../redux/actions/intentsActions";
import Uploader from "../../components/Uploader/uploader";

// Component styles
import styles from "./styles";
import { removeMessage, pushMessage } from "../../redux/actions/commonActions";
import Typography from "@material-ui/core/Typography";

import {getEnvironmentName} from "../../utils"
const environment = getEnvironmentName()
let config = require("app_configuration").CONFIGURATION[environment];

class IntentsEnabled extends Component {
  signal = true;

  state = {
    isLoading: false,
    error: null,
    search: "",
    data: {},
    loaded: false,
    editOpen: false,
    editIntent: {},
    disabled: false
  };

  getConnection = async () => {
    try {
      this.setState({ isLoading: true });
      // await this.props.fetchIntents();
      await this.props.fetchConnection(this.props.match.params.connection_name);
      this.setState({ isLoading: false, loaded: true });
    } catch (error) {
      if (this.signal) {
        this.setState({
          isLoading: false,
          loaded: true,
          error
        });
      }
    }
  };

  componentWillMount() {
    if (_.isEmpty(this.props.skill)) return;

    this.signal = true;
    this.getConnection();
  }

  onCloseEdit = refreshData => {
    this.setState({ editOpen: false });
    if (refreshData) {
      this.getConnection();
    }
  };

  onOpenEdit = intent => {
    this.setState({ editOpen: true, editIntent: intent });
  };

  componentWillReceiveProps(newProps, oldProps) {
    if (!_.isEmpty(newProps.skill) && !this.state.loaded && !this.state.isLoading) {
      this.getConnection();
    }
    this.setState({ intents: newProps.intents });
  }

  handleSearchIntents = event => {
    const searchTerm = event.target.value;
    this.setState({ search: searchTerm });
  };

  render() {
    const { classes } = this.props;
    const intents = !_.isEmpty(this.props.connection) ? this.props.connection.intents : [];
    return (
      <DashboardLayout title="Tasks" isLoading={this.state.isLoading || _.isEmpty(this.props.skill)}>
        <Grid spacing={2} container>
          <Grid item xs={12} sm={3}>
            <SearchInput
              value={this.state.search}
              className={classes.searchInput}
              onChange={this.handleSearchIntents}
              placeholder="Search Tasks"
            />
          </Grid>
          {/*{this.props.administrator ? (*/}
          {/*  <Grid item xs={12} sm={9}>*/}
          {/*    <Button variant="contained" color="primary" onClick={this.onBuildBotClick} disabled={this.state.disabled}>*/}
          {/*      BUILD RESPONSUM*/}
          {/*    </Button>*/}
          {/*  </Grid>*/}
          {/*) : (*/}
          {/*  <Grid item xs={12} sm={9} />*/}
          {/*)}*/}
          <Divider className={classes.divider} />
          <Grid item xs={12}>
            <div className={classes.listClass}>
              <IntentsEnabledList
                location={this.props.location}
                connectorName={this.props.connection.connectorName}
                connectorType={this.props.connection.type}
                displayName={_.get(this.props, "connection.display_name", false)}
                intents={intents}
                isLoading={this.state.isLoading}
                onIntentClick={this.onOpenEdit}
                getConnection={this.getConnection}
                searchTerm={this.state.search}
              />
            </div>
          </Grid>
          {/*<Grid item lg={4} md={8} xl={3} xs={12} className={classes.enabledIntents}>*/}
          {/*  <div>*/}
          {/*    <div />*/}
          {/*  </div>*/}
          {/*</Grid>*/}
          <Grid item xs={12} lg={8}>
            {["faq-dev", "faq"].indexOf(this.props.connection.connectionName) >= 0 ? (
              <div>
                <Typography component="div" variant="h5" className={classes.enabledIntents}>
                  Upload your custom FAQ file (.csv,.xls,.xlsx format):
                </Typography>
                <Uploader
                  type="faq-uploader"
                  contentType="application/csv;charset=UTF-8"
                  accepts=".csv,.xls,.xlsx"
                  administrator={this.props.administrator}
                />
              </div>
            ) : (
              <div />
            )}
            {["survey"].indexOf(this.props.connection.connectionName) >= 0 ? (
              <div>
                <Typography component="div" variant="h5" className={classes.enabledIntents}>
                  Upload your survey (.csv,.xls,.xlsx format):
                </Typography>
                <Uploader
                  type="survey-uploader"
                  contentType="application/csv;charset=UTF-8"
                  accepts=".csv,.xls,.xlsx"
                  administrator={this.props.administrator}
                />
              </div>
            ) : (
              <div />
            )}
          </Grid>
        </Grid>
        <EditIntent open={this.state.editOpen} intent={this.state.editIntent} onClose={this.onCloseEdit} />
      </DashboardLayout>
    );
  }
}

IntentsEnabled.propTypes = {
  classes: PropTypes.object.isRequired,
  fetchIntents: PropTypes.func,
  checkBotStatus: PropTypes.func,
  buildBot: PropTypes.func
};

function mapStateToProps(state) {
  return {
    cognitoUser: state.auth.cognitoUser,
    connection: state.connections["connection"] ? state.connections["connection"] : {},
    skill: state.skill,
    botBuilt: state.intents["botBuilt"] ? state.intents.botBuilt : {},
    botStatus: state.intents["botStatus"] ? state.intents.botStatus : {},
    message: state.common.message,
    administrator: _.get(state.auth.cognitoUser.attributes, "custom:role", "user") === "Administrator"
  };
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators(
      {
        fetchConnection,
        checkBotStatus,
        buildBot,
        removeMessage,
        pushMessage
      },
      dispatch
    ),
    dispatch
  };
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withStyles(styles)(IntentsEnabled))
);
